<template>
    <hb-dropdown
        v-if="networks.length"
        ref="shareDropdown"
        class="share-dropdown"
        :is-icon="false"
        :align="'bottom'"
        close-on-click
    >
        <template slot="btn">
            <button class="btn btn-outline share-button">
                <svg width="24" viewBox="0 0 24 24">
                    <path fill="#FFFFFF" fill-rule="nonzero" d="M11.1 5.176L8.394 7.882A.9.9 0 1 1 7.12 6.609l4.243-4.242a.9.9 0 0 1 1.272 0l4.243 4.242a.9.9 0 1 1-1.273 1.273L12.9 5.176v9.821a.9.9 0 1 1-1.8 0V5.176zm7.83 6.821a.9.9 0 0 1 1.8 0v6a3.9 3.9 0 0 1-3.9 3.9H7.17a3.9 3.9 0 0 1-3.9-3.9v-6a.9.9 0 0 1 1.8 0v6c0 1.16.94 2.1 2.1 2.1h9.66a2.1 2.1 0 0 0 2.1-2.1v-6z" />
                </svg>
                Share
            </button>
        </template>
        <template v-if="networks.length" slot="body">
            <ul>
                <li v-for="network in networks" :key="network.label">
                    <social-sharing
                        :url="network.url"
                        :title="network.title"
                        :description="network.description"
                        inline-template
                        @open="trackGTMEvent"
                    >
                        <network :id="network.id" :network="network.name">
                            <img :src="network.iconPath">
                            {{ network.label }}
                        </network>
                    </social-sharing>
                </li>
                <li v-clipboard:copy="url">
                    <span>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path fill="#505050" fill-rule="evenodd" d="M7.674 22.753l-3.427-3.427A.842.842 0 0 1 4 18.73V5.755c0-.465.377-.842.842-.842h2.26v-1.79c0-.62.502-1.123 1.122-1.123H19.49c.62 0 1.122.503 1.122 1.122v15.842c0 .62-.502 1.122-1.122 1.122h-1.98v2.072a.842.842 0 0 1-.841.842h-8.4a.842.842 0 0 1-.595-.247zM6.98 15.51a.618.618 0 0 0 0 1.236h7.626a.618.618 0 0 0 0-1.236H6.98zm0-3.554a.618.618 0 0 0 0 1.235h7.626a.618.618 0 0 0 0-1.235H6.979zm0-3.555a.618.618 0 1 0 0 1.236h7.626a.618.618 0 1 0 0-1.236H6.979zm1.357-3.488h8.332c.465 0 .842.377.842.842v13.096h1.305c.31 0 .561-.251.561-.561V3.797a.561.561 0 0 0-.561-.562H8.898a.561.561 0 0 0-.56.562v1.116z" />
                        </svg>
                        Copy Link
                    </span>
                </li>
            </ul>
        </template>
    </hb-dropdown>
</template>

<script>

import Vue from "vue";
import SocialSharing from "vue-social-sharing";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

export default {
    name: "ShareDropdown",
    components: {
        SocialSharing
    },
    props: {
        networks: {
            type: Array,
            required: true
        },
        networkEvents: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            overriddenNetworks: {
                "copylink": {
                    "sharer": "",
                    "type": "direct"
                }
            }
        };
    },
    computed: {
        url() {
            return window.location.host + this.$route.fullPath;
        }
    },
    methods: {
        trackGTMEvent(network) {
            const gtmEvent = {
                ...this.networkEvents[network]
            }
            this.$_gtmTrackEvent(gtmEvent);
        }
    }
}
</script>

<style lang="scss">
.share-dropdown {
    .share-button {
        font-size: 15px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        padding: 8px 11px;
        border: solid 1px #b7b7b7;
        color: white !important;

        svg {
            margin-right: 5px;
        }
    }

    ul {
        li {
            display: block;

            span {
                display: flex;
                width: 100%;
                display: block;
                color: $primary-color;
                font-family: "Gibson";
                font-size: 15px;
                font-weight: 600;
                line-height: 21px;
                padding: 5px;
                white-space: nowrap;
                border-radius: 6px;
                text-decoration: none;
                cursor: pointer;

                &:hover {
                    background-color: #020202;
                }
            }
        }
    }
}
</style>
